/**
 * src/shared/components/PermissionGuard.jsx
 *
 * Renders children only if the current admin holds the required permission.
 * Renders nothing (null) otherwise — hidden, not disabled, per spec.
 *
 * Usage:
 *   <PermissionGuard permission={PERMISSIONS.DISABLE_USERS}>
 *     <button>Disable Account</button>
 *   </PermissionGuard>
 *
 *   // Multiple permissions (requires ALL):
 *   <PermissionGuard permission={[PERMISSIONS.EDIT_USERS, PERMISSIONS.DISABLE_USERS]}>
 *     ...
 *   </PermissionGuard>
 */

import { usePermissions } from '@/shared/hooks/usePermissions';

export function PermissionGuard({ permission, children }) {
  const { can } = usePermissions();

  const permitted = Array.isArray(permission)
    ? permission.every(p => can(p))
    : can(permission);

  if (!permitted) return null;
  return children;
}
